import { useEffect } from 'react';
import { getIdentityToken } from 'common/utils/getIdentityToken';
import { useOperations as useAuthOperations } from 'store/features/auth';
import {
  useTokensMessageListener,
  useGetContourTypeFromBContour
} from 'entities/user';

import { getContourAURL, getContourBURL } from 'entities/application';
import deleteParamFromUrl from 'common/utils/deleteParamFromUrl';
import deleteClientIdFromUrl from 'common/utils/deleteClientIdFromUrl';
import { getResfreshToken as getLocalRefreshToken } from 'common/utils/auth/refreshToken';
import { getClientId } from 'common/utils/getClientId';
import { createHiddenIFrame } from 'shared/utils';
import { checkIsUserCountourB } from 'entities/user';
import { isSafariBrowser, isIOS } from 'common/utils/checkBrowserType';

import { TokenPayload } from 'common/utils/auth/parseAuthData';

import {
  IS_DIFFERENT_CONTOURS,
  IS_ACTIVE_CONTOUR_A,
  IS_ACTIVE_CONTOUR_B,
  IS_WINDOW_IFRAME,
  IS_WINDOW_IFRAME_FROM_UNKNOWN_RESOURCE
} from 'entities/application';
import { CROSS_ORIGIN_MESSAGE_TYPES } from 'entities/user';
import { USER_TYPES } from 'common/utils/userTypes';

import config from 'config';

const useAuth = () => {
  const { loginByIdentityToken, getRefreshToken, setUserType } = useAuthOperations();
  const getContourTypeFromBContour = useGetContourTypeFromBContour();
  useTokensMessageListener();

  useEffect(() => {
    const auth = async () => {
      const urlIdentityToken = getIdentityToken();
      let refreshToken = getLocalRefreshToken();
      let authData: TokenPayload | undefined;

      if (urlIdentityToken) {
        const urlClientId = getClientId();
        deleteParamFromUrl('identityToken');
        deleteClientIdFromUrl();
        authData = await loginByIdentityToken(urlIdentityToken, urlClientId) as any as TokenPayload;
        refreshToken = authData.refreshToken;
      }

      if (!urlIdentityToken && refreshToken) {
        authData = await getRefreshToken() as any as TokenPayload;
        refreshToken = authData.refreshToken;
      }

      if (IS_DIFFERENT_CONTOURS && IS_ACTIVE_CONTOUR_B && (isIOS || isSafariBrowser)) {
        window.location.replace(getContourAURL());
      }

      if (IS_DIFFERENT_CONTOURS && !isIOS && !isSafariBrowser) {
        if ((!IS_WINDOW_IFRAME || IS_WINDOW_IFRAME_FROM_UNKNOWN_RESOURCE) && IS_ACTIVE_CONTOUR_B && !refreshToken) {
          window.location.replace(getContourAURL());
        }

        if (IS_WINDOW_IFRAME && IS_ACTIVE_CONTOUR_B) {
          window.parent.postMessage({
            type: CROSS_ORIGIN_MESSAGE_TYPES.contourType,
            data: authData?.contourType
          }, config.contourA);
        }

        if (IS_ACTIVE_CONTOUR_A && !refreshToken) {
          const contourBIFrame = createHiddenIFrame(config.contourB);
          const contourType = await getContourTypeFromBContour();
          contourBIFrame.remove();

          if (checkIsUserCountourB(contourType)) {
            window.location.replace(getContourBURL());
            return;
          }
        }
      }

      if (!urlIdentityToken && !refreshToken) {
        setUserType(USER_TYPES.unautorized);
      }
    }

    auth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useAuth;
